export default "__VITE_ASSET__nPLFd9s5__"